export default "__VITE_ASSET__C2O7nAv6__"